export default "__VITE_ASSET__BIw6KmGz__"